<template>
  <div class="row"> 
    <div class="col-sm-12 col-md-10 col-lg-10">    
      <div v-if="successMessage" class="alert alert-success" role="alert">
        {{ successMessage }}
      </div>

      <div v-if="errorMessage" class="alert alert-danger" role="alert">
        {{ errorMessage }}
      </div>

  
      <card label="Watchlist Status">           
        <div v-if="model">
          <smart-select
            :disabled="!isSchemeBusinessEditor"
            id="modelwatchListStatus"
            v-model="model.schemeBusiness.watchListStatus"
            label="Watchlist Status"
            :is-required="false"
            :options="watchListStatusOptions"
          />
          <div class="mt-3 mb-2">
            <button type="button" class="btn btn-primary me-3" @click="updatewatchListStatus" :disabled="!isSchemeBusinessEditor || loading">
              Update Watchlist Status
            </button>
          </div> 
        </div>
      </card>

      <card label="Watchlist History">        
        <table class="table table-hover">
          <thead>
            <tr>
              <th>Date</th>
              <th>User</th>
              <th>Status</th>
              <th>Comments</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <template v-if="watchlistHistory.length > 0">
              <tr v-for="watchlistEntry in watchlistHistory" :key="watchlistEntry.watchListStatusDate">
                <td>{{ formatDate(watchlistEntry.watchListStatusDate) }}</td>
                <td>{{ watchlistEntry.createdBy }}</td>
                <td>{{ watchlistEntry.watchListStatus }}</td>
                <td><input type="text" v-model="watchlistEntry.comments" class="form-control" :disabled="!isSchemeBusinessEditor" /></td>
                <td>
                  <button type="button" class="btn btn-primary me-3" @click="editWatchlistHistory(watchlistEntry)" :disabled="!isSchemeBusinessEditor || loading">
                    Update
                  </button>
                </td>
              </tr>
            </template>
            <tr v-else>
              <td colspan="5" class="text-center">No watchlist history found</td>
            </tr>
          </tbody>
        </table>
      </card>
    </div>
  </div>
</template>

<script>
import {
  SmartSelect,
  Card,
} from '@trustmark-2005-ltd/trustmark-shared-components';
import { formatDate } from '../../services/scheme-common';

export default {
  name: 'SchemeBusinessWatchlist',
  components: {
    SmartSelect,
    Card,
  },
  data() {
    return {
      loading: false,
      errorMessage: null,
      successMessage: null,
    };
  },
  computed: {
    currentAccount() {
      return this.$store.state.auth.account;
    },
    isSchemeBusinessEditor() {
      if (this.currentAccount && this.currentAccount.roles) {
        return this.currentAccount.roles.includes('SchemeBusinessEditor');
      }
      return false;
    },
    watchlistHistory() {
      const history = [...this.$store.state.schemeBusinessWatchlist.watchlistHistory || []];
      history.sort((a, b) => {
        if (new Date(a.watchListStatusDate) > new Date(b.watchListStatusDate)) {
          return -1;
        }
        if (new Date(a.watchListStatusDate) < new Date(b.watchListStatusDate)) {
          return 1;
        }
        return 0;
      });
      return history.slice(0, 20);
    },
    model() {
      return this.$store.state.schemeBusiness.business;
    },
    watchListStatusOptions() {
      return ['Red', 'Amber', 'Not on the watchlist'];
    },
  },
  async mounted() {
    await this.$store.dispatch('schemeBusinessWatchlist/listWatchlistHistory', {
      schemeId: this.$route.params.schemeId,
      schemeBusinessId: this.$route.params.schemeBusinessId,
    });
  },
  methods: {
    formatDate,
    async updatewatchListStatus() {
      this.loading = true;
      this.errorMessage = null;
      this.successMessage = null;
      try {
        await this.$store.dispatch('schemeBusinessWatchlist/updateWatchlistStatus', {
          schemeId: this.$route.params.schemeId,
          schemeBusinessId: this.$route.params.schemeBusinessId,
          watchListStatus: this.model.schemeBusiness.watchListStatus,
        });
        this.successMessage = 'Watchlist status updated successfully';
        await this.$store.dispatch('schemeBusinessWatchlist/listWatchlistHistory', {
          schemeId: this.$route.params.schemeId,
          schemeBusinessId: this.$route.params.schemeBusinessId,
        });
      } catch (error) {
        this.errorMessage = error.message ?? error;
      } finally {
        this.loading = false;
      }
    },
    async editWatchlistHistory(watchlistHistory) {
      this.loading = true;
      this.errorMessage = null;
      this.successMessage = null;
      try {
        await this.$store.dispatch('schemeBusinessWatchlist/updateWatchlistHistory', {
          schemeId: this.$route.params.schemeId,
          schemeBusinessId: this.$route.params.schemeBusinessId,
          watchListStatusDate: new Date(watchlistHistory.watchListStatusDate).toISOString(),
          comments: watchlistHistory.comments,
        });
        this.successMessage = 'Watchlist history updated successfully';
      } catch (error) {
        this.errorMessage = error.message ?? error;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
